const filterButton = document.querySelector('.seminar-overview__filter-button');
const filterCloseButton = document.querySelectorAll('.seminar-filters__close, .seminar-filters__apply');
const filterEl = document.querySelector('.seminar-filters');

if (filterEl && filterButton) {
    filterButton.addEventListener('click', () => {
        filterEl.classList.add('open');
        document.body.classList.add('-no-scroll');
    });

    filterCloseButton.forEach(function(el) {
        el.addEventListener('click', () => {
            filterEl.classList.remove('open');
            document.body.classList.remove('-no-scroll');
        });
    });
}

